/**
 * Minidown is what I call the subset of Markdown that is just bold and italic, no paragraphs
 * or blocks or anything.
 *
 * ¯\_(ツ)_/¯
 */

/**
 * Node types.
 */
export enum MinidownNodeType {
  /**
   * Root node.
   */
  Root,
  /**
   * Text content.
   */
  Text,
  /**
   * Strong (bolded) content.
   */
  Strong,
  /**
   * Emphasized content.
   */
  Emphasis,
}

/**
 * Possible types of nodes.
 */
export type MinidownNode = Root | Strong | Emphasis | Text

/**
 * Contains the value of the parsed content.
 */
export interface Literal {
  value: string
}

/**
 * Contains children.
 */
export interface Parent {
  children: MinidownNode[]
}

/**
 * The root node.
 */
export interface Root extends Parent {
  type: MinidownNodeType.Root
}

/**
 * Unformatted text.
 */
export interface Text extends Literal {
  type: MinidownNodeType.Text
}

/**
 * Strong (bolded) text.
 */
export interface Strong extends Literal, Parent {
  type: MinidownNodeType.Strong
}

/**
 * Emphasized text.
 */
export interface Emphasis extends Literal, Parent {
  type: MinidownNodeType.Emphasis
}
